import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OtpboxComponent } from '../../otpbox/otpbox.component';
import { environment } from '../../../../../../environments/environment.prod';
import { Notification } from '../../../../../core/Notifications/Notification';
import { interval, Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'app-hospital-register-otp',
  templateUrl: './hospital-register-otp.component.html',
  styleUrls: ['./hospital-register-otp.component.scss']
})
export class HospitalRegisterOtpComponent implements OnInit {

  OTP: any;
  Id: any;
  Message: string = "";
  showResendButton = false;
  countdown = 2;
  minutes = 2;
  seconds = 0;
  timerSubscription: Subscription;
  Registerform: FormGroup;
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any, private Http: HttpClient, private notify: Notification, private router: Router, public dialogRef: MatDialogRef<OtpboxComponent>) { }

  ngOnInit(): void {
    console.log('Data', this._data);
    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          this.showResendButton = true;
          this.timerSubscription.unsubscribe();
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    });
  }

  resendOTP() {
    this.countdown = 2;
    this.minutes = 2;
    this.seconds = 0;
    this.showResendButton = false;
    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          this.showResendButton = true;
          this.timerSubscription.unsubscribe();
          
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    });
    this.Http.get(`${environment.Login_URL}` + `api/Authentication/SendOTP/${this._data.HOS_HospitalPhoneNo}/${'1407167973890825627'}`).subscribe((data: any) => {
      console.log('Data', data);
      this.Id = data.Id;
   
  })
}
  onSubmit() {
    this._data.OTP = this.OTP;
    this.Http.post(`${environment.Login_URL}` + `api/Authentication/HospitalRegister`, this._data).subscribe(data => {
      this.notify.successmsg("Hospital Register Successfully.");
      this.dialogRef.close(1);
      this.router.navigate(["/auth/login-hospital"]);
    })
  }
}
